module.exports = __webpack_public_path__ + "img/c_4.cd4ec54c.png";